module.exports = __webpack_public_path__ + "static/media/Program23.71386e92.jpg";